<div id="ht">
    <div id="main-cnt">
        <ion-header class="main-header block ">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb">Faq</span>
                    </div>
                </ion-buttons>
                <!-- <div slot="end" class="notification-div">
                     <div class="menu-user-icon" (click)="openPage('/my-profile')">

                     </div>
                 </div>-->
            </ion-toolbar>
            <ion-searchbar    (ionChange)="change($event)"  [(ngModel)]="searchWord"></ion-searchbar>

            <!-- edit da qui... -->
            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content overflow-auto">
            <div class="wrapper" *ngIf="faqs.length != 0">
                <div class="content">
                    <!-- edit da qui... -->
                    <ion-accordion-group *ngFor="let faq of faqs" class="" value="okaa">
                        <ion-accordion value="{{faq.id}}" class="box glass-blurred-background">
                            <ion-text slot="header">
                                <p class="question" [innerHTML]="faq.question|highlight:searchWord"></p>
                            </ion-text>
                            <ion-text slot="content">
                                <p class="answer" [innerHTML]="faq.answer|highlight:searchWord">   </p>
                            </ion-text>

                        </ion-accordion>
                    </ion-accordion-group>

                    <!-- ...a qui -->
                </div>
            </div>


            <div class="wrapper" *ngIf="faqs.length == 0">
                <div class="content">
                    <div class="box glass-blurred-background" (click)="routeTo(categories.introduzione_aziendale)">
                        <h2>{{categories.introduzione_aziendale}}</h2>
                    </div>

                    <div class="box glass-blurred-background" (click)="routeTo(categories.Procedura_KYC)">
                        <h2>{{categories.Procedura_KYC}}</h2>
                    </div>

                    <div class="box glass-blurred-background" (click)="routeTo(categories.Legalita_fiscalita)">
                        <h2>{{categories.Legalita_fiscalita}}</h2>
                    </div>

                    <div class="box glass-blurred-background" (click)="routeTo(categories.spendibilita)">
                        <h2>{{categories.spendibilita}}</h2>
                    </div>

                    <div class="box glass-blurred-background" (click)="routeTo(categories.Custodia_Gestione)">
                        <h2>{{categories.Custodia_Gestione}}</h2>
                    </div>

                    <div class="box glass-blurred-background" (click)="routeTo(categories.criptovalute_blockchain)">
                        <h2>{{categories.criptovalute_blockchain}}</h2>
                    </div>

                    <div class="box glass-blurred-background" (click)="routeTo(categories.Safety_Shield)">
                        <h2>{{categories.Safety_Shield}}</h2>
                    </div>

                    <div class="box glass-blurred-background" (click)="routeTo(categories.Safety_Shield)">
                        <h2>{{categories.Supporto_Assistenza}}</h2>
                    </div>
                    <div class="box glass-blurred-background" (click)="routeTo(categories.Moduli_Documentazioni)">
                        <h2>{{categories.Moduli_Documentazioni}}</h2>
                    </div>


                </div>
            </div>

        </ion-content>
    </div>
</div>
